import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';

export const FaqBlockHeading = ({ heading }) => {
  const navigate = useNavigate();

  if (heading.text) {
    const { url, text, linkText, linkIcon, icon } = heading;

    const HandleTopicNavigation = () => {
      navigate(url);
    };

    return (
      <p>
        {icon && <Icon icon={icon} />}
        {text && <h2 className="helpCentreTopicTitle">{text}</h2>}
        {linkText && (
          <button
            type="button"
            className="button primary text_only"
            onClick={HandleTopicNavigation}
          >
            <span className="labelText">{linkText}</span>
            <Icon icon={linkIcon} />
          </button>
        )}
      </p>
    );
  }

  return heading;
};

FaqBlockHeading.propTypes = {
  heading: PropTypes.oneOfType([
    PropTypes.shape({
      url: PropTypes.string,
      text: PropTypes.string,
      linkText: PropTypes.string,
      linkIcon: PropTypes.string,
      icon: PropTypes.string
    }),
    PropTypes.element,
    PropTypes.node
  ])
};
